
export default {
  isochronesDetails: {
    polygons: 'Polygons',
    center: 'Center',
    reachCenters: 'Reach centers',
    toggleVisibility: 'Toggle visibility',
    opacity: 'Opacity'
  }
}
